import { render } from "./ArticleDetailsView.vue?vue&type=template&id=7a5fa1d4&scoped=true"
import script from "./ArticleDetailsView.vue?vue&type=script&lang=js"
export * from "./ArticleDetailsView.vue?vue&type=script&lang=js"

import "./ArticleDetailsView.vue?vue&type=style&index=0&id=7a5fa1d4&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5fa1d4"]])

export default __exports__